angular.module('env.data.models.orderItemModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes, injectorProvider) {

        var workflowRepository;

        function getWorkflowRepository() {
            if (!workflowRepository) {
                workflowRepository = injectorProvider.get().get("workflowRepository");
            }
            return workflowRepository;
        }

        restProvider.defineModel("OrderItemModel",
            {
                extend: ['BaseModel', 'CustomFieldAwareModel'],
                url: "orderitems",
                fields: {
                    completed: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    orderId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    orderCustomerId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    orderCentreId: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    assignedCentreId: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    stepCode: {
                        serverName: 'step',
                        name: 'stepCode',
                        type: RepresentationModelFieldTypes.STRING
                    },
                    step: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.MODEL,
                        get: function (rest, model) {
                            if (model.$model.stepCode) {
                                return getWorkflowRepository().getStepByCode(model.$model.stepCode);
                            }
                            return null;
                        }
                    },
                    summary: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    createdBy: {
                        type: RepresentationModelFieldTypes.STRING
                    },
                    expectedBy: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    requiredBy: {
                        type: RepresentationModelFieldTypes.DATE
                    },
                    value: {
                        type: RepresentationModelFieldTypes.INTEGER
                    },
                    order: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.MODEL,
                        get: function (rest, model) {
                            if (model.$model.orderId) {
                                return rest
                                    .map(rest.getDefinition("OrderModel"))
                                    .map(model.$model.orderId)
                                    .willReturn("OrderModel", model.$model.orderId)
                                    .get();
                            }
                            return null;
                        }
                    },
                    customer: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.MODEL,
                        get: function (rest, model) {
                            if (model.$model.orderCustomerId) {
                                return rest
                                    .map(rest.getDefinition("CustomerModel"))
                                    .map(model.$model.orderCustomerId)
                                    .willReturn("CustomerModel", model.$model.orderCustomerId).get();
                            }
                            return null;
                        }
                    },
                    assignedCentre: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.MODEL,
                        get: function (rest, model) {
                            if (model.$model.assignedCentreId) {
                                return rest
                                    .map(rest.getDefinition("CentreModel"))
                                    .map(model.$model.assignedCentreId)
                                    .willReturn("CentreModel", model.$model.assignedCentreId).get();
                            }
                            return null;
                        }
                    },
                    jsonData: {
                        type: RepresentationModelFieldTypes.DYNAMIC,
                        decode: function (value) {
                            return value ? JSON.parse(value) : null;
                        },
                        encode: function (value) {
                            return value ? JSON.stringify(value) : null;
                        }
                    },
                    documents: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.ARRAY,
                        get: function (rest, model) {
                            return rest
                                .map(model.getDefinition())
                                .map(model.getId())
                                .map("documents")
                                .willReturn("DocumentModel")
                                .get();
                        }
                    }
                },
                methods: {
                    getDocumentIdByFilename: function (rest, model, fileName) {
                        var fileNameDecoded = window.decodeURIComponent(fileName);
                        for (var i = 0; i < model.$model.documents.length; i++) {
                            var document = model.$model.documents[i];
                            if (document && document.$model && document.$model.fileName === fileNameDecoded) {
                                return document.$model.id;
                            }
                        }
                        return null;
                    }
                }
            }
        );
    })

;
